(() => {
  const styleId = 'vb-agent-position';
  const css = `
    #root [data-testid="entrypoint"] {
      left: auto !important;
      right: max(24px, env(safe-area-inset-right, 0px)) !important;
      bottom: max(24px, env(safe-area-inset-bottom, 0px)) !important;
      margin: 0 !important;
      translate: none !important;
      transform: none !important;
      max-width: calc(100vw - 48px) !important;
    }
    @media (max-width: 900px) {
      #root [data-testid="entrypoint"] {
        right: max(16px, env(safe-area-inset-right, 0px)) !important;
        bottom: calc(16px + var(--vb-purchase-bar-height, 0px) + env(safe-area-inset-bottom, 0px)) !important;
        max-width: calc(100vw - 32px) !important;
      }
    }
  `;
  const apply = () => {
    const root = document.getElementById('ads-agent-host')?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.appendChild(style);
      const bar = document.querySelector('.vb-mobile-sticky-bar');
      if (bar) {
        const update = () => root.host.style.setProperty(
          '--vb-purchase-bar-height',
          bar.getBoundingClientRect().height + 'px'
        );
        update();
        const resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(bar);
        window.addEventListener('pagehide', () => resizeObserver.disconnect(), { once: true });
      }
    }
    return true;
  };
  if (apply()) return;
  const observer = new MutationObserver(() => {
    if (apply()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();